<template>
  <center>
    <h1>You have logged out</h1>
  </center>
</template>
